import styled from 'styled-components';

interface AcceptIconStyledProps {
    variant?: 'check' | 'cross';
}

export const AcceptIconWrapper = styled.div<AcceptIconStyledProps>`
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: ${({ variant }) => (variant === 'check' ? 'green' : 'red')};
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Text = styled.span`
font-size: 14px;
    color: #535353;
`;
